module.exports = __webpack_public_path__ + "static/img/yugao.6c8269ef.png";